import { Box, BoxProps } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

export type Page<P = {}> = FC<PropsWithChildren<P>>

export type Layout<P = {}> = FC<PropsWithChildren<P>>

/**
 * @typeparam S state object
 * @typeparam A action object
 * @typeparam P props object
 */
export type Template<
  S = {},
  A extends {
    [key in `on${Uppercase<string>}`]: (...props: unknown[]) => unknown
  } = {},
  P = {}
> = FC<PropsWithChildren<P & { state: S } & A>>
export type Organism<P = {}> = FC<PropsWithChildren<P>>

export type Cell<P = {}> = FC<PropsWithChildren<P>>

/**
 * Wrap Organization / Cell Component with each Frame Component.
 *
 * Unionのとき、Omitがうまく効かずOmitしたパラメータを使ってもエラーが出ないため注意
 */

export type OrganismFrameProps = Omit<BoxProps, 'sx'> & {
  sx?: Omit<BoxProps['sx'], MarginSxParams>
}

/**
 * Formを利用する場合、FormはOrganismとみなすので、OrganismFrameを使用しなくてよい。
 */
export const OrganismFrame: FC<OrganismFrameProps> = ({
  children,
  ...props
}) => {
  return (
    <Box component="section" {...props}>
      {children}
    </Box>
  )
}

export type CellFrameProps = Omit<BoxProps, 'sx'> & {
  sx?: Omit<BoxProps['sx'], MarginSxParams>
}

export const CellFrame: FC<CellFrameProps> = ({ children, ...props }) => {
  return <Box {...props}>{children}</Box>
}

type MarginSxParams =
  | 'm'
  | 'mx'
  | 'my'
  | 'mt'
  | 'mb'
  | 'mr'
  | 'ml'
  | 'margin'
  | 'marginTop'
  | 'marginBottom'
  | 'marginRight'
  | 'marginLeft'
